module.exports = __webpack_public_path__ + "static/media/Article 1.71d7fec5.svg";